import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Route, Router } from 'react-router-dom';
import { createBrowserHistory as createHistory } from 'history';
import { ApolloProvider } from 'react-apollo';

import App from './App';
import { ApolloClientFactory } from './domain/apolloClientFactory';
import registerServiceWorker from './registerServiceWorker';
import Login from './scenes/Login';

const history = createHistory();

ReactDOM.render(
    <ApolloProvider client={ApolloClientFactory.GetClient()}>
        <Router history={history}>
            <div>
                <Route path="/" exact={true} component={Login} />
                <Route path="/:eshop/application" component={App} />
            </div>
        </Router>
    </ApolloProvider>,
    document.getElementById('root') as HTMLElement
);

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.tsx